<template>
  <div class="reg">
    <!-- 登录注册 -->
    <el-dialog
      title="修改密码"   
      custom-class="login-form"
      :visible.sync="resetPwdVisible"
      :before-close="handleClose"
    >
      <el-container>
        <el-form
          :model="user"
          status-icon
          :rules="rules"
          ref="form"
          style="min-height:250px"
        >
            <el-form-item prop="password" v-if="$store.state.user.password">
                <el-input
                    type="password"
                    v-model="user.password"
                    placeholder="请输入旧密码"
                    auto-complete="new-password"
                ></el-input>
            </el-form-item>
            <el-form-item prop="newPassword">
                <el-input
                    type="password"
                    v-model="user.newPassword"
                    placeholder="请输入新密码"
                    auto-complete="new-password"
                ></el-input>
            </el-form-item>
            <el-form-item prop="verPassword">
                <el-input
                type="password"
                v-model="user.verPassword"
                placeholder="再次输入新密码"
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="success"
                style="background:#39C1C2;width:100%;"
                @click="resetPwd()">保存</el-button>
            </el-form-item>
        </el-form>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
import {encrypt} from '../../../utils/encryption'
export default {
  props:['resetPwdVisible'],
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.user.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      user: {
        userId: '',
        password: null,
        newPassword: null,
        verPassword: null,
      },
      isDisabled: false,
      rules: {
        password: [
          { required: true, trigger: "blur", message: "旧密码不能为空" }
        ],
        verPassword: [
          { validator: validatePass, trigger: "blur" },{
            pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/,
            message: '密码长度为8-30位，且包含数字、符号、字母'
          }
        ],
        newPassword: [
          { required: true, trigger: "blur", message: "新密码不能为空" },{
            pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/,
            message: '密码长度为8-30位，且包含数字、符号、字母'
          }
        ]
      },
    };
  },
  mounted() {
    this.user.userId = this.$store.state.user.userId
  },
  methods: {
    resetPwd(){
      this.$refs['form'].validate(valid => {
        if (valid) {
          // 验证邮箱或短信验证码
          this.user.password = encrypt(this.user.password)
          this.user.newPassword = encrypt(this.user.newPassword)
          this.user.verPassword = encrypt(this.user.verPassword)
          var api = this.systemURL + "/actuator/before/resetPwdByUserId?siteId=" + this.siteId
          this.axios.post(api, this.user).then(res => {
            if(res.data.code == 200){
              this.$message.success(res.data.msg);
              this.handleClose()
            }else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      })
    },
    handleClose(){ 
        this.stepsActive = 0
        this.$parent.changePwdVisible = false
        this.isDisabled = false
        for (let key in this.user) {
          if(key != 'userId') this.user[key] = null
        }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.grid-content {
  height: 60px;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0px;
}
.register {
  color: #1ab2ff;
  cursor: pointer;
}
.register:hover {
  color: #2c2fd6;
}
</style>

<style >
.reg .el-form {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/my/components/changePwd.vue